<template>
  <v-container v-if="$auth.isAuthenticated()" fluid  bg fill-height>
    <!--      <v-col-->
    <!--               cols="12"-->
    <!--               lg="6"-->
    <!--       >-->
    <!--           <material-chart-card-->
    <!--                   @click="$router.push('/partner-evidentions')"-->
    <!--                   :data="emailsSubscriptionChart.data"-->
    <!--                   :options="emailsSubscriptionChart.options"-->
    <!--                   :responsive-options="emailsSubscriptionChart.responsiveOptions"-->
    <!--                   color="red"-->
    <!--                   type="Bar"-->
    <!--           >-->
    <!--               <h4 class="title font-weight-light">-->
    <!--                   Evidencija snimanja-->
    <!--               </h4>-->
    <!--               <p class="category d-inline-flex font-weight-light">-->
    <!--                   Podijeljena po statusima-->
    <!--               </p>-->

    <!--               <template v-slot:actions>-->
    <!--                   <v-icon-->
    <!--                           class="mr-2"-->
    <!--                           small-->
    <!--                   >-->
    <!--                       mdi-clock-outline-->
    <!--                   </v-icon>-->
    <!--                   <span class="caption grey&#45;&#45;text font-weight-light">Za više informacija kliknite ovdje..</span>-->
    <!--               </template>-->
    <!--           </material-chart-card>-->
    <!--       </v-col>-->
    <v-layout row>
      <v-spacer></v-spacer>
      <v-row class="mx-5" style="max-width: 1400px">
        <card v-for="page in this.pages"
              :text="page.name"
              :link="page.link"
              :icon="page.icon"
              background-color="#009FE3"
              :has-round-corners="true"
              :has-box-shadow="true"
        />
      </v-row>
      <v-spacer></v-spacer>
    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import Card from '../components/portal/Cards'

  export default {
    components: {
      'card': Card,
    },
    data() {
      return {
        pages: [
          {name: 'Partneri', link: '/partners', icon: 'mdi-briefcase-account'},
          {name: 'Slajderi', link: '/sliders', icon: 'mdi-ray-start-end'},
          {name: 'Kampanje', link: '/campaigns', icon: 'mdi-lightbulb-on'},
          {name: 'Proizvodi', link: '/products', icon: 'mdi-cube'},
          {name: 'Push Notifikacije', link: '/notifications', icon: 'mdi-message-plus-outline'},
          {name: 'Podešavanja', link: '/users', icon: 'mdi-account-box-outline'}
        ],
        path: this.$router.currentRoute.path,
        total: 0,
        isChartLoaded: false,
        series: [],
        chartOptions: {
          labels: [],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        },
        series2: [],
        chartOptions2: {
          labels: [],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: 200
              },
              legend: {
                position: 'bottom'
              }
            }
          }]
        },
        stats: null,
        dailySalesChart: {
          data: {
            labels: ['M', 'T', 'W', 'T', 'F', 'S', 'S'],
            series: [
              [12, 17, 7, 17, 23, 18, 38]
            ]
          },
          options: {
            lineSmooth: this.$chartist.Interpolation.cardinal({
              tension: 0
            }),
            low: 0,
            high: 50, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
            chartPadding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            }
          }
        },
        dataCompletedTasksChart: {
          data: {
            labels: ['12am', '3pm', '6pm', '9pm', '12pm', '3am', '6am', '9am'],
            series: [
              [300, 750, 450, 300, 280, 240, 200, 190]
            ]
          },
          options: {
            lineSmooth: this.$chartist.Interpolation.cardinal({
              tension: 0
            }),
            low: 0,
            high: 100, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
            chartPadding: {
              top: 0,
              right: 0,
              bottom: 0,
              left: 0
            }
          }
        },
        emailsSubscriptionChart: {
          data: {
            labels: ['Naruceno', 'Prihvaceno', 'Odbijeno', 'U izradi', 'Zavrseno', 'Kompletirano'],
            series: [[45, 22, 33, 44, 55, 66]]
          },
          options: {
            axisX: {
              showGrid: false
            },
            low: 0,
            high: 80,
            chartPadding: {
              top: 0,
              right: 5,
              bottom: 0,
              left: 0
            }
          },
          responsiveOptions: [
            ['screen and (max-width: 640px)', {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[0]
                }
              }
            }]
          ]
        },
        headers: [
          {
            sortable: false,
            text: 'ID',
            value: 'id'
          },
          {
            sortable: false,
            text: 'Name',
            value: 'name'
          },
          {
            sortable: false,
            text: 'Salary',
            value: 'salary',
            align: 'right'
          },
          {
            sortable: false,
            text: 'Country',
            value: 'country',
            align: 'right'
          },
          {
            sortable: false,
            text: 'City',
            value: 'city',
            align: 'right'
          }
        ],
        items: [
          {
            id: 1,
            name: 'Dakota Rice',
            country: 'Niger',
            city: 'Oud-Tunrhout',
            salary: '$35,738'
          },
          {
            id: 2,
            name: 'Minerva Hooper',
            country: 'Curaçao',
            city: 'Sinaai-Waas',
            salary: '$23,738'
          },
          {
            id: 3,
            name: 'Sage Rodriguez',
            country: 'Netherlands',
            city: 'Overland Park',
            salary: '$56,142'
          },
          {
            id: 4,
            name: 'Philip Chanley',
            country: 'Korea, South',
            city: 'Gloucester',
            salary: '$38,735'
          },
          {
            id: 5,
            name: 'Doris Greene',
            country: 'Malawi',
            city: 'Feldkirchen in Kārnten',
            salary: '$63,542'
          }
        ],
        tabs: 0,
        list: {
          0: false,
          1: false,
          2: false
        }
      }
    },
    computed: {},
    methods: {
      complete(index) {
        this.list[index] = !this.list[index]
      },
    },
    created() {
      if (!this.$auth.isAuthenticated()) {
        this.$router.push('/login')
      }
      // this.readStats();

    }
  }
</script>

<style>
  .v-content__wrap {
    background-image: url('../assets/background.jpg');
    background-repeat: no-repeat;
    /*min-height: max-content;*/
    background-size: cover
  }
</style>
